import Vue from 'vue'

const state = {
    allRoutes: null,
    isLoadingRoutes: false,
};

const getters = {
    getAllRoutes: (state) => state.allRoutes,
    getIsLoadingRoutes: (state) => state.isLoadingRoutes,

};

const actions = {
    downloadRoutes ({state, rootState, commit}){
        if(!rootState.user.account.supplierId){
            return false
        }

        state.isLoadingRoutes = true
        return axios.get('/api/reservation/GetAllRoutes', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isLoadingRoutes = false
            if (response && response.status === 200 && response.data && response.data.length > 0) {
                commit('SET_ALLROUTES', response.data)
            } else {
                commit('SET_ALLROUTES', [])
            }
        }).catch(err => {
            state.isLoadingRoutes = false
        })
    }
};

const mutations = {
    SET_ALLROUTES: (state, payload) => {
        state.allRoutes = payload;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transportation.js